// Review badges (spec §3.3): an item keeps needsReview until a person edits or clears it.
const FIELDS = ["headline", "body", "decisionNeeded", "dueDate"];
const sameOwner = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

export function clearReviewOnEdit(originalItems, draftItems) {
  const byId = new Map((originalItems || []).map((i) => [i.id, i]));
  return (draftItems || []).map((d) => {
    const o = byId.get(d.id);
    if (!o || !d.needsReview) return d;
    const changed = FIELDS.some((f) => (o[f] ?? "") !== (d[f] ?? "")) || !sameOwner(o.owner, d.owner);
    return changed ? { ...d, needsReview: false } : d;
  });
}

export function countPendingReview(sections) {
  return (sections || []).reduce((n, s) => n + (s.items || []).filter((i) => i.needsReview).length, 0);
}
